import React from "react";
const HomeBuscador = {
    valida: () => {
        let urlHome = "";
        if (window.location.href.indexOf("?q=") > -1) {
            let referenUrl = window.location.href;
            let referSplit = referenUrl.split("?q=");
            urlHome = referSplit[1]
            let auxUrl = urlHome.split("#tab");
            $("#inputQ").val(decodeURIComponent(auxUrl[0]));
            const timerId = setTimeout(() => {
                $("#search").trigger("click");
            }, 1000);
            return () => {
                clearTimeout(timerId);
            };
        }
    }
}
export default HomeBuscador
